<template>
    <div>
        <div v-if="errors && errors.length > 0" class="alert alert-danger">
            <ul class="mb-0">
                <li v-for="error in errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import ApprovalService from '@/services/ApprovalService'
    export default {
        props: {
            "expenseReportID": {default: null},
            "area":{default:null}
        },
        async created() {
            this.errors = await ApprovalService.getExpenseReportValidation(this.expenseReportID, this.area);
        },
        data: function () {
            return {
                errors: null
            }
        },
        methods: {
        },
        computed: {
        }
    }
</script>